export default __webpack_public_path__ + "static/03-a-underline-life-1d387edd5c41c303aa42996fc96fa936.svg";